export default "__VITE_ASSET__rrzJg6HN__"